module.exports = __webpack_public_path__ + "static/tusas1-2356dd38a631df3d2241dfb75a5593e8.png";